<template>
  <div class="animated fadeIn">
    <Row>
      <Input clearable size="small" search @on-search="onFilterClick" v-model="keywordFilter" placeholder="名称/联系电话/联系地址" style="width: 200px; margin-right: 3px;"></Input>
      <Button size="small" type="primary" style=" margin-right: 3px;" @click="onFilterClick">查询</Button>
      <Button size="small" type="primary" style=" margin-right: 3px;" @click="addTransportVehicleInfoModal=true">添加车辆信息</Button>
      <Button size="small" type="primary" @click="queryAllPeccancy">全量查询违章</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div>
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content" ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>
    <add-vehicle-info-modal v-model="addTransportVehicleInfoModal" @on-success="onSuccess"></add-vehicle-info-modal>
    <vehicle-info-detail-modal v-model="vehicleInfoDetailModal" :initValue="vehicleInfoDetailId"
                                @on-success="onModifySuccess"></vehicle-info-detail-modal>
    <vehicle-picture-modal v-model="vehiclePictureModal" :initValue="vehiclePictureId"></vehicle-picture-modal>
    <business-note-detail-modal v-model="businessNoteDetailModal" :initValue="businessNoteInfo" :showBusinessState="false"
                                @on-success="onModifySuccess"></business-note-detail-modal>
    <change-business-user-modal v-model="changeBusinessUserModal" :initValue="changeBusinessUserTransportVehicleInfoId" @on-success="onModifySuccess"></change-business-user-modal>
    <export-vehicle-cert-modal v-model="exportVehicleCertModal" :installed="exportVehicleCertInstalled"
                               :initValue="exportVehicleCertId"></export-vehicle-cert-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal"></web-table-columns-modal>
  </div>
</template>

<script>
import AddVehicleInfoModal from '@/view/transport/components/add-vehicle-info-modal'
import VehicleInfoDetailModal from '@/view/transport/components/vehicle-info-detail-modal'
import VehiclePictureModal from '@/view/transport/components/vehicle-picture-modal'
import BusinessNoteDetailModal from '@/view/transport/components/business-note-detail-modal'
import ChangeBusinessUserModal from '@/view/transport/components/change-business-user-modal'
import ExportVehicleCertModal from '@/view/transport/components/export-vehicle-cert-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'

function calRegistrationTextColor (colorid) {
  if (colorid === 1) {
    return '#ffffff'
  } else if (colorid === 2) {
    return '#ffffff'
  } else if (colorid === 3) {
    return '#ffffff'
  } else if (colorid === 4) {
    return '#000000'
  } else {
    return '#000000'
  }
}
function calRegistrationColor (colorid) {
  if (colorid === 1) {
    return '#2b85e4'
  } else if (colorid === 2) {
    return '#ff9900'
  } else if (colorid === 3) {
    return '#1c2438'
  } else if (colorid === 4) {
    return '#f8f8f9'
  } else {
    return '#bbbec4'
  }
}

export default {
  name: 'transportvehicleinfos',
  components: {
    VehiclePictureModal,
    AddVehicleInfoModal,
    VehicleInfoDetailModal,
    BusinessNoteDetailModal,
    ChangeBusinessUserModal,
    ExportVehicleCertModal
  },
  data () {
    return {

      vehicleOwnerInfoFilter: null,

      allVehicleOwnerInfos: [],

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      businessUserFilter: null,
      marketsales: null,

      // 配置设备
      assemblePositioningDeviceModal: false,
      assembleTransportVehicleInfoId: null,

      // 指定业务跟进
      changeBusinessUserModal: false,
      changeBusinessUserTransportVehicleInfoId: null,

      // 图片管理
      vehiclePictureModal: false,
      vehiclePictureId: null,

      // 添加收入项
      addTransportVehicleInfoModal: false,

      // 车辆信息详细信息
      vehicleInfoDetailModal: false,
      vehicleInfoDetailId: null,

      // 导出证明
      exportVehicleCertModal: false,
      exportVehicleCertId: null,
      exportVehicleCertInstalled: false,

      // 业务笔记
      businessNoteDetailModal: false,
      businessNoteInfo: {
        id: null,
        businessState: null,
        content: null,
        updateDatetime: null,
        vehicleInfoId: null
      },

      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,
      totalElements: 0,
      content: [],
      pageSize: 30,
      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          width: 80
        },
        {
          title: '车牌',
          resizable: true,
          key: 'registrationNum',
          ellipsis: 'true',
          width: 120,
          sortable: 'custom',
          render: function (h, params) {
            let registrationNum = params.row.registrationNum
            if (params.row.customName) {
              registrationNum = registrationNum + '(' + params.row.customName + ')'
            }
            return h('div', {
              props: {
                disabled: false
              },
              style: {
                'text-align': 'center',
                backgroundColor: calRegistrationColor(params.row.registrationColor),
                color: calRegistrationTextColor(params.row.registrationColor)
              },
              on: {
                click: () => {
                  // this.onRegistrationNOClick(params.row)
                }
              }
            }, registrationNum)
          }
        },
        {
          title: '违章数',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'peccancyRecordCount',
          width: 100
        },
        {
          title: '查询违章时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'queryPeccancyDatetime',
          width: 160,
          render: function (h, params) {
            if (params.row.queryPeccancyDatetime) {
              let d = new Date(params.row.queryPeccancyDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '车辆所有人',
          resizable: true,
          key: 'vehicleOwnerInfoId',
          sortable: 'custom',
          ellipsis: 'true',
          minWidth: 180,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.vehicleOwnerInfoFilter = []
              val.forEach(item => {
                this.vehicleOwnerInfoFilter.push(genQueryParam('vehicleOwnerInfoId', 'EQ', item))
              })
            } else {
              this.vehicleOwnerInfoFilter = null
            }
            this.setPage(1)
          },
          render: (h, params) => {
            if (params.row.vehicleOwnerInfo) {
              return h('label', params.row.vehicleOwnerInfo.shortName)
            }
          }
        },
        {
          title: '客户',
          resizable: true,
          key: 'clientInfoId',
          sortable: 'custom',
          ellipsis: 'true',
          minWidth: 180,
          render: (h, params) => {
            let display = []
            if (params.row.clientInfo) {
              display.push(h('div', params.row.clientInfo.name + '(' + params.row.clientInfo.phoneNum + ')'))
            } else {
              display.push(h('div', '无'))
            }
            return h('div', display)
          }
        },
        {
          title: '车架号',
          resizable: true,
          key: 'vin',
          sortable: 'custom',
          ellipsis: 'true',
          width: 180
        },
        {
          title: '车辆类型',
          resizable: true,
          key: 'vehicleTypeId',
          ellipsis: 'true',
          width: 180,
          render: (h, params) => {
            if (params.row.vehicleType) {
              return h('label', params.row.vehicleType.name)
            }
          }
        },
        {
          title: '发动机号',
          resizable: true,
          key: 'engineNum',
          ellipsis: 'true',
          width: 180
        },
        {
          title: '下次年审日期',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'yearCheckDatetime',
          width: 160,
          render: function (h, params) {
            if (params.row.yearCheckDatetime) {
              let d = new Date(params.row.yearCheckDatetime)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        // {
        //   title: '下次季审日期',
        //   resizable: true,
        //   sortable: 'custom',
        //   ellipsis: 'true',
        //   tooltip: 'true',
        //   key: 'quarterCheckDatetime',
        //   width: 160,
        //   render: function (h, params) {
        //     if (params.row.quarterCheckDatetime) {
        //       let d = new Date(params.row.quarterCheckDatetime)
        //       return h('div', d.Format('yyyy年MM月dd日'))
        //     }
        //   }
        // },
        {
          title: '交强险有效期日期',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'compulsoryInsuranceDatetime',
          width: 160,
          render: function (h, params) {
            if (params.row.compulsoryInsuranceDatetime) {
              let d = new Date(params.row.compulsoryInsuranceDatetime)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        {
          title: '商业险有效期日期',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'commerceInsuranceDatetime',
          width: 160,
          render: function (h, params) {
            if (params.row.commerceInsuranceDatetime) {
              let d = new Date(params.row.commerceInsuranceDatetime)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        {
          title: '挂靠费到费期日期',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'transportServiceDatetime',
          width: 160,
          render: function (h, params) {
            if (params.row.transportServiceDatetime) {
              let d = new Date(params.row.transportServiceDatetime)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        // {
        //   title: '跟进业务员',
        //   resizable: true,
        //   key: 'businessUserId',
        //   ellipsis: 'true',
        //   tooltip: 'true',
        //   width: 120,
        //   filters: [],
        //   filterMultiple: true,
        //   filterRemote: (val) => {
        //     if (val && val.length > 0) {
        //       this.businessUserFilter = []
        //       val.forEach(item => {
        //         this.businessUserFilter.push(genQueryParam('businessUserId', 'EQ', item))
        //       })
        //     } else {
        //       this.businessUserFilter = null
        //     }
        //     this.setPage(1)
        //   },
        //   render: function (h, params) {
        //     if (params.row.businessUser) {
        //       let name = null
        //       if (params.row.businessUser.realName) {
        //         name = params.row.businessUser.realName
        //       } else if (params.row.businessUser.nickName) {
        //         name = params.row.businessUser.nickName
        //       } else if (params.row.businessUser.name) {
        //         name = params.row.businessUser.name
        //       }
        //       return h('div', name)
        //     }
        //   }
        // },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          fixed: 'right',
          width: 320,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.vehicleInfoDetailId = params.row.id
                    this.vehicleInfoDetailModal = true
                  }
                }
              }, '详细信息'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.vehiclePictureId = params.row.id
                    this.vehiclePictureModal = true
                  }
                }
              }, '图片管理'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    store.dispatch('PeccancyRecordServ_AnalyzeSingle', {
                      params: { transportVehicleInfoId: params.row.id },
                      urlparams: null
                    }).then(() => {
                      this.$Message.success('查询成功')
                    }).catch(err => {
                      this.$Message.error(err)
                    })
                  }
                }
              }, '查询违章'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '删除',
                      content: '<p>确认删除</p>',
                      onOk: () => {
                        store.dispatch('TransportVehicleInfoServ_DeleteObj', {
                          params: { id: params.row.id },
                          urlparams: null
                        }).then(() => {
                          this.$Message.success('删除成功')
                          this.onSuccess()
                        }).catch(err => {
                          this.$Message.error(err)
                        })
                      },
                      onCancel: () => {

                      }
                    })
                  }
                }
              }, '删除')
            ])
          }
        }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'TransportVehicleInfoServ_GetPage'
    ]),
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    queryAllPeccancy () {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>全量查询违章</p>',
        onOk: () => {
          store.dispatch('PeccancyRecordServ_AnalyzeAll', {
            params: null
          }).then(() => {
            this.$Message.success('查询成功')
            this.setPage(1)
          }).catch(err => {
            this.$Message.error(err)
          })
        },
        onCancel: () => {
          let userId = this._initValue
          store.dispatch('VehicleInfoGroupServ_GetDetail', {
            params: { id: userId }
          }).then(() => {
            this.vehicleInfoGroup = store.getters.get_VehicleInfoGroup_GetDetailResult
          }).catch(err => {
            this.$Message.error(err)
          })
        }
      })
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage()
    },
    onColumnUpdate () {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '跟进业务员') {
          this.columns[i].filters = this.marketsales
          break
        }
        if (this.columns[i].title === '车辆所有人') {
          this.columns[i].filters = this.allVehicleOwnerInfos
          break
        }
      }
    },
    onFilterClick () {
      this.setPage(1)
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage()
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let qo5 = null
      let qo6 = null

      let queryParams = []
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }

      if (this.businessUserFilter) {
        qo5 = this.businessUserFilter
      }
      if (this.vehicleOwnerInfoFilter) {
        qo6 = this.vehicleOwnerInfoFilter
      }

      store.dispatch('TransportVehicleInfoServ_ClientGetPage', {
        params: null,
        urlparams: {
          q: queryParams,
          qo5: qo5,
          qo6: qo6,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        if (store.getters.get_TransportVehicleInfo_ClientGetPageResult) {
          this.totalElements = store.getters.get_TransportVehicleInfo_ClientGetPageResult.totalElements
          this.content = store.getters.get_TransportVehicleInfo_ClientGetPageResult.content
          this.pageSize = store.getters.get_TransportVehicleInfo_ClientGetPageResult.size
        } else {
          this.totalElements = 0
          this.content = []
          this.pageSize = 0
        }
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage () {
      this.setPage(this.pageIndex)
    }
  },
  computed: {
    // totalElements() {
    //   if (store.getters.get_TransportVehicleInfo_GetPageResult) {
    //     return store.getters.get_TransportVehicleInfo_GetPageResult.totalElements
    //   } else {
    //     return 0
    //   }
    // },
    // content() {
    //   if (store.getters.get_TransportVehicleInfo_GetPageResult) {
    //     return store.getters.get_TransportVehicleInfo_GetPageResult.content
    //   } else {
    //     return []
    //   }
    // },
    // pageSize() {
    //   if (store.getters.get_TransportVehicleInfo_GetPageResult) {
    //     return store.getters.get_TransportVehicleInfo_GetPageResult.size
    //   } else {
    //     return 0
    //   }
    // }
  },
  mounted () {
    this.$nextTick(() => {
      store.dispatch('UserServ_GetAllUsers', {
        params: {},
        urlparams: { roleIds: [7] }
      }).then(() => {
        let marketsales = store.getters.get_User_GetAllUsersResult
        this.marketsales = marketsales.map(item => {
          return { label: item.realName, value: item.id }
        })
        store.dispatch('VehicleOwnerInfoServ_ClientGetPage', {
          params: null,
          urlparams: null
        }).then(() => {
          let allVehicleOwnerInfos = store.getters.get_VehicleOwnerInfo_ClientGetPageResult.content
          this.allVehicleOwnerInfos = []
          allVehicleOwnerInfos.forEach(item => {
            this.allVehicleOwnerInfos.push({ label: item.shortName, value: item.id })
          })
          this.onColumnUpdate()
        }).catch(err => {
          this.$Message.error(err)
        })
      }).catch(err => {
        this.$Message.error(err)
      })

      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
